<template>
  <div class="container">
    <div class="main">
      <fade-animation>
        <common-gallary :imgs="url" v-show="true"></common-gallary>
      </fade-animation>
    </div>
  </div>
</template>

<script>
import CommonGallary from "../../components/Gallary";
import FadeAnimation from "../../components/FadeAnimation";
import storage from "../../utils/storage";
export default {
  name:"viewImage",
  components: {
    CommonGallary,
    FadeAnimation
  },
  data () {
    return {
      url:[]
    }
  },
  created(){
    let fileList = JSON.parse(storage.get("viewImgList"))
    
    for (let i = 0; i < fileList.length; i++) {
      if(fileList[i].postfix.indexOf('mp4')==-1){
        this.url.push(fileList[i].path)
      }
    }
  },
  methods: {
    back(){
      window.history.back(-1);
    },
    details(){

    }
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/css/common.less";
.container{
  width: 100%;
  height: 100%;
  background: #000;
}
.main{
  width:100%;
  height:668px;
  margin-top: 206px;
}
.img{
  width:100%;
  // height:668px;
}
</style>
